/** Design tokens shared by the expert app and the client dashboard. */

export const PRIMARY = "#009DE0";
export const SECONDARY = "#002A5C";
export const PAGE_BG = "#F5F7FA";
export const BORDER = "#DEE3EA";

export const APP_NAME = "SPOF360";

/** ENGIE Laborelec branding, white wordmark for the coloured top bar. */
export const LOGO_URL = `${import.meta.env.BASE_URL}logo-engie-laborelec-white.png`;

export const HEADER_GRADIENT = `linear-gradient(100deg, ${SECONDARY} 0%, #0072B8 52%, ${PRIMARY} 100%)`;
/** Wordmark gradient, light enough to stay legible on the header. */
export const BRAND_GRADIENT =
  "linear-gradient(95deg, #FFFFFF 0%, #C9F0FF 42%, #4FD1FF 100%)";
export const TITLE_GRADIENT = `linear-gradient(90deg, ${SECONDARY} 0%, ${PRIMARY} 100%)`;

export const CARD_SHADOW =
  "0 1px 2px rgba(0,42,92,0.05), 0 10px 24px rgba(0,42,92,0.06)";
export const CARD_SHADOW_HOVER =
  "0 2px 4px rgba(0,42,92,0.08), 0 18px 36px rgba(0,42,92,0.14)";

/** KKS impact 1..4 as set in the expert editor, lowest to highest. */
export const RISK_COLORS: Record<number, string> = {
  4: "#E53935",
  3: "#F57C00",
  2: "#FBC02D",
  1: "#43A047",
};

/** SPOF register "Risk Category", worst first, aligned on the KKS impact palette. */
export const RISK_LEVELS = ["Severe", "High", "Medium", "Low"];

export const RISK_LEVEL_COLORS: Record<string, string> = {
  Severe: RISK_COLORS[4],
  High: RISK_COLORS[3],
  Medium: RISK_COLORS[2],
  Low: RISK_COLORS[1],
};

/** Accent of the KPI cards that carry no risk level of their own. */
export const KPI_NEUTRAL = "#1B6FD4";

/** Mitigation "Implementation Phase", keyed lowercase since the register spells it freely. */
export const PHASE_COLORS: Record<string, string> = {
  "quick win": "#1AA5A0",
  "medium term": "#1B6FD4",
  "long term": SECONDARY,
};

/** Every sortable header shows a faint arrow; the one in use is drawn full and underlined. */
export function sortLabelSx(active: boolean) {
  return {
    fontWeight: active ? 800 : 500,
    textDecoration: active ? "underline" : "none",
    textUnderlineOffset: 4,
    "& .MuiTableSortLabel-icon": {
      opacity: active ? 1 : 0.25,
      color: "inherit",
    },
  };
}
